import React from 'react';

import {Helmet, useNavigate, useParams} from 'views/module';

import JobView from 'views/scenes/career/job_scenes/JobView';
import JOB_SOURCES from 'views/scenes/career/job_source';

import FLAGS, {useFlag} from 'utils/feature_flags/flags';

const LoomJobView = () => {
  const params = useParams();
  const jobRn = params.jobRn;
  const jobReadFlag = useFlag(FLAGS.JOB_READS_FROM_LOOM);
  const navigate = useNavigate();

  React.useEffect(() => {
    if (jobReadFlag.isLoading || jobReadFlag.isEnabled) return;

    navigate('/career', {replace: true});
  }, [jobReadFlag.isEnabled, jobReadFlag.isLoading, navigate]);

  if (jobReadFlag.isLoading || !jobReadFlag.isEnabled) return null;

  return (
    <>
      <Helmet>
        <title>Quilt: Job Details (Loom)</title>
      </Helmet>
      <JobView
        jobRn={jobRn}
        jobSource={JOB_SOURCES.LOOM}
      />
    </>
  );
};

export default LoomJobView;
